/* zsozo.js — egyéni szekciók JavaScriptje */
(function () {

  /* ===== Sticky header ===== */
  var header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  /* ===== Mobile nav toggle ===== */
  var navToggle = document.getElementById('navToggle');
  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      header.classList.toggle('nav-open');
    });
    document.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () { header.classList.remove('nav-open'); });
    });
  }

  /* ===== Custom cursor (zz-cursor) ===== */
  var cursor = document.getElementById('zz-cursor');
  if (cursor && window.matchMedia('(hover: hover)').matches) {
    var cx = 0, cy = 0, mx = 0, my = 0;
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cursor.classList.add('is-active');
    });
    (function loop() {
      cx += (mx - cx) * 0.18;
      cy += (my - cy) * 0.18;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll('[data-zz-hover]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('is-hover'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('is-hover'); });
    });
  }

  /* ===== Scroll reveal (.zz-reveal) ===== */
  var revealEls = document.querySelectorAll('.zz-reveal');
  if (revealEls.length) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 60);
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { revealObs.observe(el); });
  }

  /* ===== Animated stat counters (.zz-stat__num) ===== */
  var counters = document.querySelectorAll('.zz-stat__num');
  if (counters.length) {
    var counterObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.count, 10);
        var duration = 1400;
        var start = performance.now();
        (function tick(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if (progress < 1) requestAnimationFrame(tick);
        })(start);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { counterObs.observe(el); });
  }

  /* ===== FAQ accordion (.zz-faq__item) ===== */
  document.querySelectorAll('.zz-faq__item').forEach(function (item) {
    var btn = item.querySelector('.zz-faq__question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.zz-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ===== Product gallery thumbnails (.product-gallery__thumb) ===== */
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) {
    document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        galleryMain.src = thumb.dataset.img;
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ===== Hero card stack is defined inline in section ===== */

  /* ===== Product gallery — prev/next arrows + swipe ===== */
  function initProductGallery() {
    var gallery = document.querySelector('.zz-prod__gallery');
    var mainEl = document.getElementById('zzProdMain');
    if (!gallery || !mainEl) return;
    if (gallery.dataset.zzGallery) return;
    gallery.dataset.zzGallery = '1';

    var items = Array.prototype.slice.call(mainEl.querySelectorAll('.zz-prod__main-item'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.zz-prod__thumb'));
    if (items.length < 2) return;

    /* Wrap thumbs container for fade edges */
    var thumbsEl = document.getElementById('zzProdThumbs');
    if (thumbsEl && thumbsEl.parentNode && !thumbsEl.parentNode.classList.contains('zz-prod__thumbs-wrap')) {
      var wrap = document.createElement('div');
      wrap.className = 'zz-prod__thumbs-wrap';
      thumbsEl.parentNode.insertBefore(wrap, thumbsEl);
      wrap.appendChild(thumbsEl);
    }

    /* Arrows */
    var mainWrap = mainEl.parentNode;
    mainWrap.style.position = 'relative';
    var prevBtn = document.createElement('button');
    prevBtn.className = 'zz-gallery-arrow zz-gallery-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Előző kép');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    var nextBtn = document.createElement('button');
    nextBtn.className = 'zz-gallery-arrow zz-gallery-arrow--next';
    nextBtn.setAttribute('aria-label', 'Következő kép');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    mainEl.appendChild(prevBtn);
    mainEl.appendChild(nextBtn);

    var current = 0;

    function updateArrows() {
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === items.length - 1;
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, items.length - 1));
      items.forEach(function(el, i) { el.classList.toggle('is-active', i === current); });
      thumbs.forEach(function(el, i) { el.classList.toggle('is-active', i === current); });
      if (thumbs[current] && thumbsEl) {
        thumbsEl.scrollTo({ left: thumbs[current].offsetLeft - 40, behavior: 'smooth' });
      }
      updateArrows();
    }

    prevBtn.addEventListener('click', function() { goTo(current - 1); });
    nextBtn.addEventListener('click', function() { goTo(current + 1); });

    thumbs.forEach(function(thumb, idx) {
      thumb.addEventListener('click', function() { goTo(idx); });
    });

    /* Swipe */
    var touchStartX = 0;
    mainEl.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    mainEl.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    updateArrows();
  }

  setTimeout(initProductGallery, 500);
  document.addEventListener('shopify:section:load', function() { setTimeout(initProductGallery, 300); });

})();